@if (user?.IsSelf) {
  <h6 class="mb-0 d-inline-block">
    {{ user?.FirstName }} {{ user?.LastName }}
  </h6>
}

@if (!user?.IsSelf && (user?.FirstName || user?.LastName)) {
  <h6 class="mb-0 d-inline-block">
    {{ user?.FirstName }} {{ user?.LastName }}
  </h6>
}

@if (!user?.IsSelf && !user?.FirstName && !user?.LastName && user?.EMail) {
  <h6 class="mb-0 d-inline-block">
    {{ user?.EMail }}
  </h6>
}

@if (!user?.IsSelf && !user?.FirstName && !user?.LastName && !user?.EMail) {
  <h6 class="mb-0 d-inline-block">
    Unbekannt
  </h6>
}

@if (humanizeDate) {
  <time class="d-inline-block ms-2 mb-0 text-muted smaller" placement="right" title="{{activity.Timestamp | date : 'dd.MM.yyyy'}} um {{activity.Timestamp | date : 'HH:mm '}} Uhr">
    {{ activity.Timestamp | humanizedDate }} @if (activity.Project && showProjectName) {
    <a routerLink="/projects/{{ activity.Project.Id }}">in '{{ activity.Project.Name }} m|w|d'</a>
  }
</time>
}

@if (!humanizeDate) {
  <time class="d-inline-block ms-2 mb-0 text-muted smaller" placement="right">
    am {{activity.Timestamp | date : 'dd.MM.yy'}} um {{activity.Timestamp | date : 'HH:mm '}} Uhr @if (activity.Project && showProjectName) {
    <a routerLink="/projects/{{ activity.Project.Id }}">in '{{ activity.Project.Name }} m|w|d'</a>
  }
</time>
}